
const FilterBox = () => {

    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_858_2653)">
                <path d="M37.1284 3.125H3.12842V37.125H37.1284V3.125Z" fill="white" stroke="#EBEAE9"
                      strokeWidth="6.24305" strokeMiterlimit="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_858_2653">
                    <rect width="40" height="40" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    )
}

export default FilterBox;
